import React from 'react';
import Login from '../components/Login';
import { Card, CardContent, Box, Typography, Chip, Grid } from '@mui/material';
import { useAuth } from '../components/AuthContext';
import LatestAssignments from '../components/Assignment/LatestAssignments';
import { UserRole } from '../common/enums';

const Home: React.FC = () => {
  console.log('Render home')
  const user = useAuth();
  const isAuthorRole = user.user?.role === UserRole.Admin || user.user?.role === UserRole.Tutor;

  const getRoleEmoji = (role: UserRole) => {
    switch (role) {
      case UserRole.Admin: return '👑';
      case UserRole.Tutor: return '👨‍🏫';
      case UserRole.Student: return '👩‍🎓';
      default: return '👤';
    }
  };

  return (
    <Box p={3}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h2" gutterBottom sx={{ fontWeight: 700 }}>
          📚 TutorTrack
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Älykäs opiskelu- ja opetusalusta
        </Typography>
      </Box>

      {user.user ? (
        <>
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12}>
              <Card elevation={3} sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                <CardContent>
                  <Box display="flex" alignItems="center" gap={2}>
                    <span style={{ fontSize: '2.5rem' }}>{getRoleEmoji(user.user.role as UserRole)}</span>
                    <Box>
                      <Typography variant="h4" gutterBottom>
                        Hei, {user.user.name}! 👋
                      </Typography>
                      <Typography variant="h6">
                        Tervetuloa takaisin oppimismatkaasi
                      </Typography>
                      <Chip 
                        label={`${user.user.role} käyttäjä`}
                        sx={{ 
                          mt: 1, 
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          color: 'white',
                          fontWeight: 600
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {user.user.role === UserRole.Student && (
            <LatestAssignments /> 
          )}

          {user.user.role === UserRole.Admin && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      🎓 Hallinnoi opinto-ohjelmia
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Luo ja muokkaa opinto-ohjelmia, kursseja ja oppimismateriaaleja
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      📊 Seuraa edistymistä
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Tarkkaile opiskelijoiden suoriutumista ja anna palautetta
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}

          {isAuthorRole && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      📖 Ohjaa kursseja
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Anna tehtäviä, arvioi suorituksia ja tue oppimista
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      🎯 Luo tehtäviä
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Suunnittele ja julkaise uusia harjoituksia opiskelijoille
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <>
          <Box mb={4}>
            <Card elevation={3}>
              <CardContent>
                <Box textAlign="center" py={3}>
                  <Typography variant="h4" gutterBottom color="primary">
                    🚀 Aloita oppimismatka TutorTrackissa!
                  </Typography>
                  <Typography variant="body1" color="text.secondary" paragraph>
                    Kirjaudu sisään Google-tililläsi ja löydä tehokas tapa oppia ja opettaa
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Box>

          <Grid container spacing={3} mb={4}>
            <Grid item xs={12} md={4}>
              <Card elevation={2}>
                <CardContent>
                  <Box textAlign="center">
                    <Typography variant="h2" sx={{ fontSize: '3rem' }}>👩‍🎓</Typography>
                    <Typography variant="h6" gutterBottom color="primary">
                      Opiskelijoille
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Rekisteröidy Google-tililläsi ja aloita oppiminen heti
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card elevation={2}>
                <CardContent>
                  <Box textAlign="center">
                    <Typography variant="h2" sx={{ fontSize: '3rem' }}>👨‍🏫</Typography>
                    <Typography variant="h6" gutterBottom color="primary">
                      Ohjaajille
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Rekisteröidy ja ota yhteyttä ylläpitoon saadaksesi ohjaajan oikeudet
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card elevation={2}>
                <CardContent>
                  <Box textAlign="center">
                    <Typography variant="h2" sx={{ fontSize: '3rem' }}>🤖</Typography>
                    <Typography variant="h6" gutterBottom color="primary">
                      AI-avustus
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Tekoäly auttaa oppimisessa ja antaa henkilökohtaista palautetta
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="center">
            <Login />
          </Box>
        </>
      )}
    </Box>
  );
};

export default Home;
